import { INITIALIZE_FORM } from '../actionTypes';
import { companyRolesActions } from '../reducer';

export default (values) => companyRolesActions[INITIALIZE_FORM](values);
